<script>
import axios from "axios";
import moment from "moment";

export default {
  props: {
    open: {
      type: Boolean,
      required: false,
      default: false,
    },
    dispatch: {
      type: [Object, String],
      required: false,
    },
  },
  emits: ["close-modal", "refetch"],
  data() {
    return {
      type: undefined,
      fetchIsPending: undefined,
      fetchIsSuccess: undefined,
      fetchIsError: undefined,
    };
  },
  methods: {
    async checkManifiesto() {
      if (!this.dispatch.tipo?.numero_manifiesto) {
        this.$emit("close-modal");
        this.$swal({
          icon: "error",
          title: "¡Error!",
          text: "Este despacho no tiene numero de manifiesto.",
        });
        return false;
      }
      return true;
    },
    async checkAgent() {
      try {
        const { data } = await axios.get(
          `/api/admin/check-agent/${this.dispatch.id}`
        );
        return data?.isValid;
      } catch (error) {
        this.$swal({
          icon: "error",
          title: "¡Error!",
          text: "Hubo un problema de conexión con comext.aduanas",
        });
      }
    },
    async fetchAforos() {
      this.fetchIsPending = true;

      let isValid = await this.checkAgent();

      if (!isValid) {
        this.fetchIsError = true;
        this.fetchIsPending = false;
        this.fetchIsSuccess = false;

        this.$emit("close-modal");
        this.$swal({
          icon: "error",
          title: "¡Error!",
          text: `El administrador no ha configurado las credenciales de comext.aduanas.cl para el agente ${this.dispatch?.agente?.nombre}.`,
        });
        return;
      }

      try {
        const query = {
          responseType: "blob",
          manifiesto_id: this.dispatch.tipo?.numero_manifiesto,
        };

        const { data, headers } = await axios.get(
          `/api/admin/fetch-consulta-aforo/${this.dispatch.id}`,
          query
        );

        if (data) {
          const href = URL.createObjectURL(data);
          const link = document.createElement("a");
          link.href = href;
          link.setAttribute(
            "download",
            "aforo" +
              "-" +
              this.dispatch.id +
              "-" +
              moment(new Date()).format("DD-MM-YYYY") +
              ".pdf"
          );

          document.body.appendChild(link);
          link.click();

          document.body.removeChild(link);
          URL.revokeObjectURL(href);

          this.$emit("close-modal");
          this.$emit("refetch");
          this.fetchIsSuccess = true;
          this.fetchIsError = false;
        }
      } catch (err) {
        this.$emit("close-modal");

        const text = await err?.response?.data.text();
        const json = JSON.parse(text);

        if (json.errors && json.errors.length > 0) {
          this.$emit("close-modal");
          this.$swal({
            icon: "error",
            title: "¡Error!",
            text: json.errors.join("\n"),
          });
          return;
        }

        this.fetchIsError = true;
      }

      this.fetchIsPending = false;
    },
  },
  watch: {
    open: async function () {
      if (this.open == true) {
        this.agentIsValid = undefined;
        this.agentIsError = undefined;
        this.agentIsPending = undefined;

        this.fetchIsSuccess = undefined;
        this.fetchIsPending = undefined;
        this.fetchIsError = undefined;
        //await this.checkAgent();

        if (await this.checkManifiesto()) {
          await this.fetchAforos();
        }
      }
    },
  },
  mounted() {},
};
</script>

<template>
  <div>
    <b-modal
      :visible="open"
      no-backdrop
      hide-footer
      hide-header
      @hidden="() => $emit('close-modal')"
      centered
    >
      <template v-slot:modal-header></template>

      <div class="flex h-48 flex-row items-center gap-4 justify-center">
        <b-spinner
          v-if="fetchIsPending"
          class="text-primary"
          style="width: 3em; height: 3em"
        />
      </div>

      <template v-slot:modal-footer>
        <div></div>
      </template>
    </b-modal>
  </div>
</template>
